export { Tag } from './ui/Tag';
export type { TagItemData, TagProps } from './ui/Tag';
